export const effluentCodes = {
  domestic_effluents: "Efl1",
  industrial_effluents: "Efl2",
  combined_effluents: "Efl3",
  sludge_and_mud: "Efl4",
  recycled_effluents: "Efl5",
  treatment_cost_domestic_effluents: "Efl6",
  industrial_effluent_treatment_cost: "Efl7",
  combined_treatment_cost: "Efl8",
  sludge_treatment_cost: "Efl9",
};

export const waterCodes = {
  water_domestic_municipal_network: "Agu1",
  municipal_network_water_production: "Agu2",
  combined_municipal_network_water: "Agu3",
  water_cost_domestic_municipal_network: "Agu4",
  water_cost_municipal_network_production: "Agu5",
  water_cost_combined_municipal_network: "Agu6",
  domestic_groundwater: "Agu7",
  groundwater_production: "Agu8",
  groundwater_combined: "Agu9",
  domestic_groundwater_cost: "Agu10",
  groundwater_production_cost: "Agu11",
  groundwater_combined_cost: "Agu12",
  rainwater: "Agu13",
  surface_water: "Agu14",
  distilled_water: "Agu15",
  reused_water: "Agu16",
  recycled_water: "Agu17",
  steam_condensed_water: "Agu18",
};

export const productionCodes = {
  production_volume: "VP1",
  // standardized_production: "VPS",  // estandarizada — oculta temporalmente
  billing_volume: "VF1",
  // standardized_billing: "VFS",     // estandarizada — oculta temporalmente
};

export const socialCodes = {
  days_worked: "Soc1",
  normal_hours_worked: "Soc2",
  fifty_percent_overtime: "Soc3",
  one_hundred_percent_overtime: "Soc4",
  female_production_workers: "Soc5",
  male_production_workers: "Soc6",
  other_gender_production_workers: "Soc7",
  female_administrative_workers: "Soc8",
  male_administrative_workers: "Soc9",
  administrative_workers_other_genders: "Soc10",
  female_temporary_workers: "Soc11",
  male_temporary_workers: "Soc12",
  temporary_workers_other_genders: "Soc13",
  female_workers_leadership_positions: "Soc14",
  male_workers_leadership_positions: "Soc15",
  workers_under_cct: "Soc16",
  work_accidents_with_sick_days: "Soc17",
  in_itine_accidents: "Soc18",
  first_aid_without_sick_days: "Soc19",
  hours_training_social_issues: "Soc20",
  hours_training_hys: "Soc21",
  hours_environmental_awareness_training: "Soc22",
  volunteer_hours: "Soc23",
  complaints_or_suggestions_received: "Soc24",
};

export const wasteCodes = {
  paper_and_cardboard: "re1",
  plastic: "re2",
  fabric_scraps: "re3",
  metal_clean: "re4",
  wood: "re5",
  food_waste: "re6",
  general_trash: "re7",
  glass: "re8",
  leather: "re9",
  foam_eva: "re10",
  empty_cans_or_containers: "re11",
  rubber: "re12",
  other_non_hazardous_waste: "re13",
  electronic_waste: "Re14",
  empty_chemical_containers: "Re15",
  cleaning_pesticide_containers: "Re16",
  batteries: "Re17",
  fluorescent_tubes: "Re18",
  cooking_oil: "Re19",
  maintenance_oil: "Re20",
  lubricants: "Re21",
  paint_waste: "Re22",
  coal_ashes: "Re23",
  rubber_hazardous: "Re24",
  chemicals: "Re25",
  contaminated_materials: "Re26",
  ink_cartridges: "Re27",
  medical_waste: "Re28",
  other_hazardous_waste: "Re29",
};

export const dangerousCodes = {
  chemicals_sent_to_reuse_or_recycle: "PF1",
  lubricants_sent_to_reuse_or_recycle: "PF2",
  oils_sent_to_reuse_or_recycle: "PF1",
  machines_and_equipment_sent_to_reuse_or_recycle: "PF2",
  electronic_waste_sent_to_reuse_or_recycle: "PF1",
  other_dangerous_wastes_sent_to_reuse_or_recycle: "PF2",
  chemicals_sent_to_incineration: "PF1",
  lubricants_sent_to_incineration: "PF2",
  oils_sent_to_incineration: "PF1",
  machines_and_equipment_sent_to_incineration: "PF2",
  electronic_waste_sent_to_incineration: "PF1",
  other_dangerous_wastes_sent_to_incineration: "PF2",
  chemicals_sent_to_landfill: "PF1",
  lubricants_sent_to_landfill: "PF2",
};

export const energyCodes = {
  electricity_standard: "En1",
  electricity_cost: "En2",
  renewable_energies: "En3",
  renewable_energies_produced_and_consumed_on_site: "En4",
  steam: "En5",
  steam_cost: "En6",
  natural_gas: "En7",
  natural_gas_cost: "En8",
  glp: "En9",
  glp_cost: "En10",
  heavy_fuel_oil: "En11",
  cost_of_heavy_fuel_oil: "En12",
  light_fuel_oil: "En13",
  cost_of_light_fuel_oil: "En14",
  coal: "En15",
  coal_cost: "En16",
  diesel: "En17",
  diesel_cost: "En18",
  gasoline_for_internal_vehicles: "En19",
  gasoline_cost_of_internal_vehicles: "En20",
  biomass: "En21",
  biomass_cost: "En22",
};

export const kpisCodes = {
  total_fuel_energy_consumption: "PF1",
  total_electrical_energy_consumption: "PF2",
  total_energy_consumption: "PF1",
  total_renewable_energy: "PF2",
  percentage_of_renewable_energy: "PF1",
  percentage_energy_from_fossil_fuels: "PF2",
  total_energy_consumed_per_productive_unit: "PF1",
  total_cost_of_energy_consumed: "PF2",
  total_scope_1: "PF1",
  total_scope_2: "PF2",
  total_scope_3: "PF2",
  total_emissions_per_unit_produced: "En",
  total_emissions: "E",
  scope_percentage_1: "En",
  scope_percentage_2: "En",
  scope_percentage_3: "En",
};

export const energyFieldMain = ["electricity", "fuels"];

export const kpisFieldMain = ["energy_indicators", "greenhouse_gas_indicators"];

export const airEmissionsCodes = {
  spinning_of_threads: "Air1",
  finishings: "Air2",
  solvents: "Air3",
  adhesives_cementation: "Air4",
  impression: "Air5",
  tincture: "Air6",
  tension_frames_or_other_heating_processes: "Air7",
  stain_cleaners: "Air8",
  chemicals: "Air9",
  ods: "Air10",
  pm: "Air11",
  vocs: "Air12",
  hap_tap: "Air13",
  boiler: "Air14",
  generators: "Air15",
  combustion_engines: "Air16",
  industrial_ovens: "Air17",
  heating_and_ventilation: "Air18",
  refrigerant_containing_device: "Air19",
  air_conditioning: "Air20",
  other_sources_operations_facilities: "Air21",
};

export const fuelsCodes = {
  natural_gas: "Veh1",
  natural_gas_cost: "Veh2",
  glp: "Veh3",
  glp_cost: "Veh4",
  diesel: "Veh5",
  diesel_cost: "Veh6",
  biodiesel: "Veh7",
  cost_biodiesel: "Veh8",
  gasoline: "Veh9",
  gasoline_cost: "Veh10",
  ethanol: "Veh11",
  ethanol_cost: "Veh12",
  electricity_vehicles: "Veh13",
  cost_electricity_vehicles: "Veh14",
  natural_gas_vehicles: "Veh15",
  glp_vehicles: "Veh16",
  diesel_vehicles: "Veh17",
  biodiesel_vehicles: "Veh18",
  gasoline_vehicles: "Veh19",
  ethanol_vehicles: "Veh20",
  electric_vehicles: "Veh21",
};

export const waterKIPsCodes = {
  industrial_water_kpis: "KPIagu1",
  domestic_water_kpis: "KPIagu2",
  rainwate_kpis: "KPIagu3",
  municipal_water_kpis: "KPIagu4",
  surface_water_kpis: "KPIagu5",
  well_water_kpis: "KPIagu6",
  recycled_water_kpis: "KPIagu7",
  reused_water_kpis: "KPIagu8",
  total_water_cost: "KPIagu9",
};

export const socialKPIsCodes = {
  average_female_workers: "KPIsoc1",
  average_male_workers: "KPIsoc2",
  total_permanent_workers: "KPIsoc3",
  total_temporary_workers: "KPIsoc4",
  total_workers: "KPIsoc5",
  total_days_worked: "KPIsoc6",
  total_hours_worked: "KPIsoc7",
  total_fifty_percent_overtime: "KPIsoc8",
  total_one_hundred_percent_overtime: "KPIsoc9",
  total_hours_worked_extra_and_normal: "KPIsoc10",
  average_female_workers_leadership_positions: "KPIsoc11",
  average_male_workers_leadership_positions: "KPIsoc12",
  average_female_total: "KPIsoc13",
  average_male_total: "KPIsoc14",
  total_work_accidents_with_sick_days: "KPIsoc15",
  total_accidents_first_aid: "KPIsoc16",
  total_in_itine_accidents: "KPIsoc17",
  total_accidents: "KPIsoc18",
  total_hours_training_social_issues: "KPIsoc19",
  total_hours_training_hys: "KPIsoc20",
  total_hours_environmental_awareness_training: "KPIsoc21",
  total_volunteer_hours: "KPIsoc22",
  total_complaints_or_suggestions_received: "KPIsoc23",
};

export const energyKPIsCodes = {
  electricity_standard_kpis: "KPIener1",
  renewable_energies_kpis: "KPIener2",
  steam_kpis: "KPIener3",
  natural_gas_kpis: "KPIener4",
  glp_kpis: "KPIener5",
  heavy_fuel_oil_kpis: "KPIener6",
  light_fuel_oil_kpis: "KPIener7",
  coal_kpis: "KPIener8",
  diesel_kpis: "KPIener9",
  gasoline_for_internal_vehicles_kpis: "KPIener10",
  biomass_kpis: "KPIener11",
  total_energy_kpis: "KPIener12",
  fuels_kpis: "KPIener13",
  electricity_cost_kpis: "KPIener14",
  fuels_cost_kpis: "KPIener15",
};

export const vehiclesKPIsCodes = {
  natural_gas_kpis: "KPIVeh1",
  glp_kpis: "KPIVeh2",
  heavy_fuel_oil_kpis: "KPIVeh3",
  light_fuel_oil_kpis: "KPIVeh4",
  diesel_kpis: "KPIVeh5",
  gasoline_internal_vehicles_kpis: "KPIVeh6",
  biodiesel_kpis: "KPIVeh7",
  biogas_kpis: "KPIVeh8",
  ethanol_kpis: "KPIVeh9",
  electricity_vehicles_kpis: "KPIVeh10",
  total_fuels_kpis: "KPIVeh11",
  cost_fuels_kpis: "KPIVeh12",
};

export const wasteKPIsCodes = {
  paper_and_cardboard_kpis: "KPIres1",
  plastic_kpis: "KPIres2",
  fabric_or_scraps_kpis: "KPIres3",
  metal_kpis: "KPIres4",
  wood_kpis: "KPIres5",
  other_non_hazardous_kpis: "KPIres6",
  food_kpis: "KPIres7",
  glass_kpis: "KPIres8",
  leather_kpis: "KPIres9",
  foam_kpis: "KPIres10",
  waste_electronic_kpis: "KPIres11",
  empty_cans_or_containers_not_dangerous_kpis: "KPIres12",
  empty_cans_or_containers_dangerous_kpis: "KPIres13",
  batteries_kpis: "KPIres14",
  fluorescent_tubes_kpis: "KPIres15",
  cooking_oil_kpis: "KPIres16",
  maintenance_oil_kpis: "KPIres17",
  lubricants_kpis: "KPIres18",
  paint_remains_kpis: "KPIres19",
  coal_ashes_kpis: "KPIres20",
  rubber_kpis: "KPIres21",
  other_non_hazardous_waste_kpis: "KPIres22",
  other_hazardous_waste_kpis: "KPIres23",
  leftover_food_kpis: "KPIres24",
  total_non_hazardous_waste_kpis: "KPIres25",
  total_dangerous_kpis: "KPIres26",
  total_recyclable_kpis: "KPIres27",
  total_reused_kpis: "KPIres28",
  total_incinerated_kpis: "KPIres29",
  total_energy_recovery_kpis: "KPIres30",
  total_wastes_kpis: "KPIres31",
};

export const effluentKPIsCodes = {
  industrial_effluent_kpis: "KPIefl1",
  domestic_effluent_kpis: "KPIefl2",
  total_effluents_kpis: "KPIefl3",
  effluent_recycled_kpis: "KPIefl4",
  sludge_kpis: "KPIefl5",
  sludge_disposition_cost_kpis: "KPIefl6",
  domestic_effluent_treatment_cost_kpis: "KPIefl7",
  industrial_effluent_treatment_cost_kpis: "KPIefl8",
  total_effluent_treatment_cost_kpis: "KPIefl9",
};

export const airEmissionsKPIsCodes = {
  total_chlorofluorocarbons: "KPIair1",
  total_hydrochlorofluorocarbons: "KPIair2",
  total_hydrofluorocarbons: "KPIair3",
  total_hydrofluoroolefins: "KPIair4",
  total_perfluorocarbons: "KPIair5",
  total_carbon_dioxide: "KPIair6",
  total_carbon_monoxide: "KPIair7",
  total_ammonia: "KPIair8",
  total_propane: "KPIair9",
  total_isobutane: "KPIair10",
  total_propylene: "KPIair11",
  total_ethylene: "KPIair12",
  total_hexafluoroethane: "KPIair13",
  total_octafluoropropane: "KPIair14",
  total_chlorotrifluoromethane: "KPIair15",
  total_chlorodifluoromethane: "KPIair16",
  total_tetrafluoroethane: "KPIair17",
  total_trifluoromethane: "KPIair18",
  total_pentafluoroethane: "KPIair19",
  total_hexafluoropropylene: "KPIair20",
  total_hydrogen: "KPIair21",
  total_methane: "KPIair22",
  total_oxygen: "KPIair23",
  total_nitrogen: "KPIair24",
  total_hydrogen_sulfide: "KPIair25",
  total_nitrous_oxide: "KPIair26",
};
